import EventsModule from "../../modules/Events";
import axios from "axios";
import { API_BASE_URL } from "../../config/constants/endpoints";
import { GetStaticPaths } from "next";

const Events = () => {
  return <EventsModule />;
};

export const getStaticProps = async () => {
  const { data } = await axios.get<EventResponse>("/v1/event?page=1&size=10", {
    baseURL: API_BASE_URL,
  });
  return {
    props: {
      fallback: {
        ["/v1/event?page=1&size=10"]: data,
      },
    },
    revalidate: 300, // 5 minutes
  };
};

export default Events;
